import React, {useState} from "react";
import {Snackbar} from "@vkontakte/vkui";
import {Icon28CheckCircleOutline, Icon28ErrorCircleOutline, Icon28CoinsOutline} from "@vkontakte/icons";
import BonusStore from "../store/bonus";

export const useSnackbarProvider = () => {
    const [snackbar, setSnackbar] = useState(null);

    const showSuccessSnackbar = (text) => {
        setSnackbar(
            <Snackbar
                before={<Icon28CheckCircleOutline fill="var(--vkui--color_accent_green)"/>}
                onClose={() => setSnackbar(null)}
            >
                {text}
            </Snackbar>
        );
    };

    const showErrorSnackbar = (text) => {
        setSnackbar(
            <Snackbar
                before={<Icon28ErrorCircleOutline fill="var(--vkui--color_icon_negative)"/>}
                onClose={() => setSnackbar(null)}
            >
                {text}
            </Snackbar>
        );
    };

    const showSnackbar = (text) => {
        setSnackbar(
            <Snackbar
                onClose={() => setSnackbar(null)}
            >
                {text}
            </Snackbar>
        );
    };

    const showPurchaseSuccessSnackbar = (coinsAmount) => {
        setSnackbar(
            <Snackbar
                before={<Icon28CheckCircleOutline fill="var(--vkui--color_accent_green)" />}
                after={
                    <div className="flex items-center gap-1">
                        <Icon28CoinsOutline fill="var(--vkui--color_accent_orange)" width={20} height={20} />
                        <span className="text-sm font-medium">{BonusStore.coins}</span>
                    </div>
                }
                onClose={() => setSnackbar(null)}
            >
                <div className="flex flex-col">
                    <div className="font-medium">Purchase completed!</div>
                    <div className="text-sm opacity-75">
                        Received {coinsAmount} coins
                    </div>
                </div>
            </Snackbar>
        );
    };

    return {
        snackbar,
        snackbarContext: { 
            showSuccessSnackbar, 
            showErrorSnackbar, 
            showSnackbar,
            showPurchaseSuccessSnackbar
        },
    };
};
